// extracted by mini-css-extract-plugin
module.exports = {"responsivePathFill":"Error404_responsivePathFill__x6b4P"};